import { useCallback, useState } from 'react';

const useForceUpdate = (): VoidFunction => {
    const [, setUpdate] = useState<number>(0);

    return useCallback(() => setUpdate(prevValue => ++prevValue), []);
};

export default useForceUpdate;
